export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";